// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"64e785b5","416":"2bc2a064","421":"22efd733","566":"b24dca60","614":"084c75c7"}[chunkId] + ".chunk.js";
};